// Get the current environment
const isDevelopment = import.meta.env.DEV;

// Base configuration that's shared between environments
const baseConfig = {
  SOCKET_OPTIONS: {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    withCredentials: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    timeout: 10000,
    auth: {
      apiKey: '2475cdb1-46c1-48ea-8b19-880a01c55215',
      assistantId: 'e74d592a-ce5d-47c6-af59-88d9d372f789'
    }
  },
  API_OPTIONS: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-VAPI-API-KEY': '2475cdb1-46c1-48ea-8b19-880a01c55215',
      'X-VAPI-ASSISTANT-ID': 'e74d592a-ce5d-47c6-af59-88d9d372f789'
    },
    credentials: 'include',
    mode: 'cors'
  }
};

// Environment-specific configurations
const envConfig = {
  development: {
    API_ENDPOINT: 'http://localhost:3000/api',
    WS_ENDPOINT: 'http://localhost:3000'
  },
  production: {
    API_ENDPOINT: 'https://backend-8pjb.onrender.com/api',
    WS_ENDPOINT: 'https://backend-8pjb.onrender.com'
  }
};

// Export the combined configuration
export const VAPI_CONFIG = {
  ...baseConfig,
  ...envConfig[isDevelopment ? 'development' : 'production']
};